
const SHOW_KIOSK_WARNING = 'SHOW_KIOSK_WARNING';
const HIDE_KIOSK_WARNING = 'HIDE_KIOSK_WARNING';

export function showKioskWarning(warningOptions) {
    return dispatch => {
        dispatch({
            type: SHOW_KIOSK_WARNING,
            warningType: warningOptions.warningType
        });
    };
}
export function hideKioskWarning() {
    return dispatch => {
        dispatch({
            type: HIDE_KIOSK_WARNING
        });
    };
}
const initialState = {
    warningType: null
};
const kioskWarningReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_KIOSK_WARNING: {
            return {
                warningType: action.warningType
            };
        }
        case HIDE_KIOSK_WARNING: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export function currentKioskWarningType(state) {
    return state.kioskWarningReducer.warningType;
}

export default kioskWarningReducer;



// WEBPACK FOOTER //
// ./src/reducers/kioskWarningReducer.js